const module = { name: 'Fandango/modal', exports: {} }; const exports = module.exports;



import { default as $ } from 'swug-fdRequire-call:jQuery';



import { swig as swig } from 'require-core';



import { Fandango as Fandango_dtmData } from 'require-core';

const { dtmData } = Fandango_dtmData;


import { Fandango_debugLog as debugLog } from 'require-core';



import { Fandango_Dialog as Dialog } from 'require-global';



const Selectors = {
    MODAL_CLOSE_BTN: '.js-modal-close-btn',
    MODAL_CONFIRM_BTN: '.js-modal-confirm-btn',
    OFFER_DESCRIPTION: '.offer-footer h4',
    OFFER_MODAL: '#offer-modal-',
}


const modalHandlers = {}
function modalTracking(modalSelector) {
    const satellite = window._satellite;
    const description = $(modalSelector).find(Selectors.OFFER_DESCRIPTION).text();
    if (dtmData && satellite && description) {
        dtmData.pageName = 'gwp modal | ' + description;
        satellite.track('GWP Modal');
    }
}
function initModal(openSelector, modalSelector, dtmTracking) {
    const { EventNames } = Dialog;
    const dialog = new Dialog(modalSelector);
    const dlg = document.getElementById(dialog.id);
    if (!dlg) {
        return;
    }
    dlg.style.display = 'none';
    function onOpenerClick(e) {
        e.preventDefault();
        if (dtmTracking) {
            modalTracking(modalSelector);
        }
        dlg.style.display = '';
        setTimeout(() => dialog.open(), 10);
    }
    function onCloseClick() {
        dialog.close();
    }
    let eventType = null;
    function onTransitionEnd() {
        if (eventType === EventNames.CLOSED) {
            dlg.style.display = 'none';
        }
    }
    function onDlgEvent(event) {
        eventType = event.type;
    }
    const $id = `${openSelector}-${modalSelector}`;
    const $opener = $(openSelector);
    const $closeBtn = $(`${modalSelector} ${Selectors.MODAL_CLOSE_BTN}`);
    if (modalHandlers[$id]) {
        const handlers = modalHandlers[$id];
        $opener.off('click', handlers.onOpenerClick);
        $closeBtn.off('click', handlers.onCloseClick);
        dlg.removeEventListener('transitionend', handlers.onTransitionEnd);
        handlers.dialog.off(EventNames.OPENED, handlers.onDlgEvent);
        handlers.dialog.off(EventNames.CLOSED, handlers.onDlgEvent);
    }
    modalHandlers[$id] = {
        onOpenerClick,
        onCloseClick,
        onTransitionEnd,
        onDlgEvent,
        dialog
    };
    $opener.on('click', onOpenerClick);
    $closeBtn.on('click', onCloseClick);
    dlg.addEventListener('transitionend', onTransitionEnd);
    dialog.on(EventNames.OPENED, onDlgEvent);
    dialog.on(EventNames.CLOSED, onDlgEvent);
}
function showModal(selector, template, viewModel, onConfirm, onClose) {
    const inDocumentModal = document.querySelector(selector);
    if (inDocumentModal) {
        inDocumentModal.outerHTML = swig.render(template, viewModel);
        const modal = document.querySelector(selector);
        const dialog = new Dialog(selector);
        const confirmBtnElement = modal.querySelector(Selectors.MODAL_CONFIRM_BTN);
        confirmBtnElement?.addEventListener('click', () => {
            if (onConfirm) {
                onConfirm(dialog);
            }
            dialog.close();
        });
        const closeBtnElements = modal.querySelectorAll(Selectors.MODAL_CLOSE_BTN);
        closeBtnElements.forEach(closeBtnElement => closeBtnElement.addEventListener('click', () => dialog.close()));
        dialog.on(Dialog.EventNames.CLOSED, () => {
            if (onClose) {
                onClose(dialog);
            }
        });
        setTimeout(() => dialog.open(), 10);
    }
}
function offers(openSelector) {
    $(openSelector).each(function () {
        const { offerId } = this.dataset;
        if (!offerId) {
            return debugLog.warn(module.name, 'offer opener missing id');
        }
        const modalID = `${Selectors.OFFER_MODAL}${offerId}`;
        if (!document.querySelector(modalID)) {
            return debugLog.warn(module.name, modalID, 'element not found');
        }
        initModal(this, modalID, false);
    });
}
function merch(openSelector) {
    $(openSelector).each(function () {
        const { id } = this.dataset;
        if (!id) {
            return debugLog.warn(module.name, 'merch opener missing id');
        }
        const modalID = `${Selectors.OFFER_MODAL}${id}`;
        if (!document.querySelector(modalID)) {
            return debugLog.warn(module.name, modalID, 'element not found');
        }
        initModal(this, modalID, true);
    });
}
function init(openSelector, modalSelector) {
    const openers = !!(document.querySelector(openSelector));
    if (openers) {
        initModal(openSelector, modalSelector);
    }
}
module.exports = {
    init,
    offers,
    merch,
    showModal,
};
export default module.exports;